module.exports = __webpack_public_path__ + "static/media/girl-large.10af67e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Age/girl-large.svg
// module id = 390
// module chunks = 0